import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, LayoutDashboard } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Market Map', path: '/market-map' },
    { name: 'About', path: '/about' },
    { name: 'Process', path: '/process' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_0e33f67c-8e2b-40b5-8e43-a87d8ad0485f/artifacts/j7xc6nbc_Image%2B%281%29.png.webp" 
            alt="Last Mile Advisors - Energy Procurement Experts" 
            className="logo-image"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="nav-desktop">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'nav-link-active' : ''}`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="header-cta-desktop" style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          {user ? (
            <Link to="/dashboard">
              <Button className="btn-primary" data-testid="header-dashboard-btn" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <LayoutDashboard size={16} /> Dashboard
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/login">
                <Button className="btn-secondary" data-testid="header-login-btn">Sign In</Button>
              </Link>
              <Link to="/contact">
                <Button className="btn-primary">Request Consultation</Button>
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="nav-mobile">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link-mobile ${isActive(link.path) ? 'nav-link-active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          {user ? (
            <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)}>
              <Button className="btn-primary w-full mt-4" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
                <LayoutDashboard size={16} /> Dashboard
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)}>
                <Button className="btn-secondary w-full mt-4">Sign In</Button>
              </Link>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
                <Button className="btn-primary w-full mt-2">Request Consultation</Button>
              </Link>
            </>
          )}
        </nav>
      )}
    </header>
  );
};

export default Header;
